import React from "react";
import "../App.css";
import { useNavigate, Link } from "react-router-dom";

function Header() {
  // const navigate = useNavigate();
  // const log=()=>{
  //   setTimeout(() => {
  //     navigate("/login");
  //   }, 200);
  // }
  return (
    <div>
      <header id="header-part">
        <div class="header-top d-none d-lg-block">
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <div class="header-contact text-lg-left text-center">
                  <ul>
                    <li>
                      <img src="images/all-icon/map.png" alt="icon" />
                      <span>Rohtak (Haryana, India)</span>
                    </li>
                    <li>
                      <img src="images/all-icon/email.png" alt="icon" />
                      <span>samridhisofficial@gmail.com</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="header-opening-time text-lg-right text-center">
                  <p>Opening Hours : Monday to Saturay - 8 Am to 5 Pm</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="header-logo-support pt-30 pb-30">
          <div class="container">
            <div class="row">
              <div class="col-lg-4 col-md-4">
                <div class="logo">
                  <Link to="/">
                    <h3>HR School</h3>
                    <img src="images/favicon.png" alt="Logo" id="hrlogo" />
                  </Link>
                </div>
              </div>
              <div class="col-lg-8 col-md-8">
                <div class="support-button float-right d-none d-md-block">
                  <div class="support float-left">
                    <div class="icon">
                      <img src="images/all-icon/support.png" alt="icon" />
                    </div>
                    <div class="cont">
                      <p>Need Help? call us free</p>
                      <span>0000000000</span>
                    </div>
                  </div>
                  <div class="button float-left">
                    {/* <button class="main-btn" onClick={log}>Admin Login</button> */}
                    {/* <Link to="/login" class="main-btn">
                      Admin Login
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="navigation">
          <div class="container">
            <div class="row">
              <div class="col-lg-10 col-md-10 col-sm-9 col-8">
                <nav class="navbar navbar-expand-lg">
                  <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>

                  <div
                    class="collapse navbar-collapse sub-menu-bar"
                    id="navbarSupportedContent"
                  >
                    <ul class="navbar-nav mr-auto">
                      <li class="nav-item">
                        <Link class="active" to="/">
                          Home
                        </Link>
                      </li>
                      <li class="nav-item">
                        <Link to="/about">About us</Link>
                      </li>
                      <li class="nav-item">
                        <Link to="/gallery">Gallery</Link>
                        <ul class="sub-menu">
                          <li>
                            <Link to="/allpicture">All Picture</Link>
                          </li>
                        </ul>
                      </li>
                      <li class="nav-item">
                        <Link to="/choosetemplates">Certificate</Link>
                        
                          
                      </li>
                      {/* <li class="nav-item">
                        <Link to="/game">Game</Link>
                        
                          
                      </li> */}
                      {/* <li class="nav-item">
                        <a href="#">Blog</a>
                        <ul class="sub-menu">
                          <li>
                            <a href="#">Blog</a>
                          </li>
                          <li>
                            <a href="#">Blog Singel</a>
                          </li>
                        </ul>
                      </li> */}
                      <li class="nav-item">
                        <Link to="/analysis">Articles Analysis</Link>
                        {/* <ul class="sub-menu">
                          <li>
                            <a href="#">Shop</a>
                          </li>
                          <li>
                            <a href="#">Shop Singel</a>
                          </li>
                        </ul> */}
                      </li>
                      <li class="nav-item">
                        <Link to="/contact">Contact</Link>
                        
                      </li>
                    </ul>
                  </div>
                </nav>
                
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-4">
                <div class="right-icon text-right">
                  <ul>
                    <li>
                      <a href="#" id="search">
                        <i class="fa fa-search"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-shopping-bag"></i>
                        <span>0</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
